export default __webpack_public_path__ + "static/media/EM0730.34I-22032_-15024_0.b6559c4e.jpg";